'use strict';

var react = require('react');

/* eslint-disable unicorn/filename-case */
const useUUID = (uuidProps) => {
    const { idOverride, prefix } = uuidProps ?? {};
    const [uuid] = react.useState(() => crypto.randomUUID());
    if (idOverride) {
        return idOverride;
    }
    const id = `${prefix ?? 'id' /* ensuring that the id always starts with a letter */}-${uuid}`.replaceAll(' ', '-');
    return id;
};

exports.useUUID = useUUID;
//# sourceMappingURL=useUUID.js.map
